<po-page-list
  p-title="Lista UR"
  [p-breadcrumb]="breadcrumb">
  <po-container class="po-md-12">
    <po-input class="po-md-2"
      name="filtroCodigo"
      p-label="Código"
      [(ngModel)]="tabelaPrincipalFiltro.CZ05COD"
      p-maxlength="6">
    </po-input>
    <po-input class="po-md-2"
      name="filtroUR"
      p-label="UR"
      [(ngModel)]="tabelaPrincipalFiltro.CZ05UR"
      p-maxlength="10">
    </po-input>
    <po-select class="po-md-2"
      name="filtroTipo"
      p-label="Tipo"
      [(ngModel)]="tabelaPrincipalFiltro.CZ05TIPO"
      [p-options]="[
        {value: '1', label: 'Rústico'},
        {value: '2', label: 'Remanufatura'},
        {value: ' ', label: 'Todos'}]">
    </po-select>
    <po-select class="po-md-2"
      name="filtroBloqueado"
      p-label="Status"
      [(ngModel)]="tabelaPrincipalFiltro.CZ05BLOQ"
      [p-options]="[
        {value: 'S', label: 'Bloqueado'},
        {value: 'N', label: 'Habilitado'},
        {value: ' ', label: 'Todos'}]">
    </po-select>
    <po-button class="po-md-1 po-mt-3"
      p-label="Filtrar"
      p-kind="primary"
      (p-click)="buscaRegistros()">
    </po-button>
    <po-button class="po-md-1 po-mt-3"
      p-label="Incluir UR"
      (p-click)="postUR(true,[])">
    </po-button>
  </po-container>
  <po-table class="po-md-12 po-mt-1"
    p-container="shadow"
    [p-height]="550"
    [p-items]="tabelaPrincipalItens"
    [p-columns]="poTableColumns"
    [p-actions]="poTableActions"
    p-hide-columns-manager="true"
    p-striped="true">
  </po-table>
</po-page-list>

<po-modal #modalIncluirUR p-title="{{inclui?'Incluir UR':'Editar UR'}}" p-hide-close="true">
  <form #f="ngForm">
    <po-input class="po-md-2"
      name="UR"
      p-label="UR"
      [(ngModel)]="dadosUR.CZ05UR"
      p-maxlength="10"
      p-required="true"
      [p-disabled]="inclui?'false':'true'">
    </po-input>
    <po-decimal class="po-md-3"
      name="volume"
      p-label="Volume"
      [(ngModel)]="dadosUR.NZ05VOLUME"
      p-maxlength="14"
      p-decimals-length="4"
      [p-min]="1"
      p-required="true"
      (p-change)="alteraValorVolume()">
    </po-decimal>
    <po-decimal class="po-md-3"
      name="saldo"
      p-label="Saldo"
      [(ngModel)]="dadosUR.NZ05SALDO"
      p-maxlength="12"
      p-decimals-length="8"
      [p-min]="0.001"
      p-required="true">
    </po-decimal>
    <po-select class="po-md-2"
      name="Tipo"
      p-label="Tipo"
      [(ngModel)]="dadosUR.CZ05TIPO"
      [p-options]="[
        {value: '1', label: 'Rústico'},
        {value: '2', label: 'Remanufatura'}]"
      p-required="true">
    </po-select>
    <po-select class="po-md-2"
      name="Bloqueado"
      p-label="Bloqueado?"
      [(ngModel)]="dadosUR.CZ05BLOQ"
      [p-options]="[
        {value: 'S', label: 'Sim'},
        {value: 'N', label: 'Não'}]"
      p-required="true">
    </po-select>
  </form>
  <po-modal-footer>
    <po-button class="po-md-2"
      p-label="Cancelar"
      p-danger="true"
      p-icon="po-icon-close"
      (p-click)="cancelarUR()">
    </po-button>
    <po-button class="po-md-2"
      p-label="Salvar"
      p-kind="primary"
      p-icon="po-icon-ok"
      (p-click)="salvarUR()">
    </po-button>
  </po-modal-footer>
</po-modal>
